//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { service, getToken } from "../../services/api.js";
import YearMonthPicker from "../YearMonthPicker.vue";
import ReportHeader from "./ReportHeader.vue";
import SnackBarMixin from '../SnackBarMixin.vue';
import SnackBar from "../SnackBar.vue";
import PieChart from "./PieChart.vue";
import BarChart from "./BarChart.vue";

export default {
  extends: SnackBarMixin,
  components: {
    "report-header": ReportHeader,
    "year-month-picker": YearMonthPicker,
    "pie-chart": PieChart,
    "bar-chart": BarChart,
    "snackbar": SnackBar,
  },
  data: () => ({
    date: {
      year: null,
      month: null,
      monthName: null,
    },
    summaryData: undefined,
    expendingsData: undefined,
    visibility: false,
  }),
  watch: {
    "date.month": async function () {
      this.getSummary();
    },
  },
  methods: {
    getDate(value) {
      this.date.year = value.split("-")[0];
      this.date.month = value.split("-")[1];
      this.date.formattedName = this.getMonthName(
        this.date.month,
        this.date.year
      );
    },
    getMonthName(month, year) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return `${monthNames[month - 1]} of ${year}`;
    },
    getExpendings() {
      const token = getToken();
      service
        .getExpenses(token, this.date.year, this.date.month)
        .then((res) => {
          this.expendingsData = res.data;
          this.visibility = true;
        })
        .catch(() => {
          this.visibility = false;
          this.showError('This Month has no Associated Categorized Expenses');
        });
    },
    getOnlySummary() {
      const token = getToken();
      service.getSummary(token, this.date.year, this.date.month).then((res) => {
        this.summaryData = res.data;
      });
    },
    getSummary() {
      const token = getToken();
      service
        .getSummary(token, this.date.year, this.date.month)
        .then((res) => {
          this.summaryData = res.data;
          this.visibility = true;
        })
        .then(() => {
          service
            .getExpenses(token, this.date.year, this.date.month)
            .then((res) => {
              this.expendingsData = res.data;
              this.visibility = true;
            });
        })
        .catch(() => {
          this.visibility = false;
          this.showError('This Month has no Associated Summary');
        });
    }
  },
};
